import React from "react";
import { Container } from "reactstrap";

const Footer = () => {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <footer>
      <Container fluid className="footer-section text-center">
        <span>
          © {getCurrentYear()}, Thanapoom Phithakjarukorn. All Rights Reserved.
        </span>
      </Container>
    </footer>
  );
};

export default Footer;
